import {
  createSipClientLinkedDeviceAsync,
  deleteSipClientLinkedDeviceAsync,
  getAllSipClientLinkedDeviceByLicenseAsync,
  getAllSipClientLinkedDeviceByLicenseCountAsync,
  getSipClientLinkedDeviceByIdAsync,
  updateSipClientLinkedDeviceAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSipClientLinkedDeviceAsync = () =>
  useMutation(createSipClientLinkedDeviceAsync);

export const useGetSipClientLinkedDeviceByIdAsync = () =>
  useMutation(getSipClientLinkedDeviceByIdAsync);

export const useGetAllSipClientLinkedDeviceByLicenseAsync = () =>
  useMutation(getAllSipClientLinkedDeviceByLicenseAsync);

export const useGetAllSipClientLinkedDeviceByLicenseCountAsync = () =>
  useMutation(getAllSipClientLinkedDeviceByLicenseCountAsync);

export const useUpdateSipClientLinkedDeviceAsync = () =>
  useMutation(updateSipClientLinkedDeviceAsync);

export const useDeleteSipClientLinkedDeviceAsync = () =>
  useMutation(deleteSipClientLinkedDeviceAsync);
